import apiClient from './client';
import type { Program, CreateProgramRequest, UpdateProgramRequest, PaginatedResponse } from '../../types';

export interface ProgramListParams {
  page?: number;
  limit?: number;
  sortBy?: string;
  sortOrder?: 'ASC' | 'DESC';
  search?: string;
  partnerId?: string;
}

export const programsApi = {
  /**
   * Get all programs with optional filtering and pagination
   */
  list: async (params?: ProgramListParams): Promise<PaginatedResponse<Program>> => {
    const queryParams = new URLSearchParams();

    if (params?.page) queryParams.set('page', String(params.page));
    if (params?.limit) queryParams.set('limit', String(params.limit));
    if (params?.sortBy) queryParams.set('sortBy', params.sortBy);
    if (params?.sortOrder) queryParams.set('sortOrder', params.sortOrder);
    if (params?.search) queryParams.set('search', params.search);
    if (params?.partnerId) queryParams.set('partnerId', params.partnerId);

    const queryString = queryParams.toString();
    const url = `/api/programs${queryString ? `?${queryString}` : ''}`;

    return apiClient.getPaginated<Program>(url);
  },

  /**
   * Get a single program by ID
   */
  getById: async (id: string): Promise<Program> => {
    return apiClient.get<Program>(`/api/programs/${id}`);
  },

  /**
   * Create a new program
   */
  create: async (data: CreateProgramRequest): Promise<Program> => {
    return apiClient.post<Program>('/api/programs', data);
  },

  /**
   * Update a program
   */
  update: async (id: string, data: UpdateProgramRequest): Promise<Program> => {
    return apiClient.put<Program>(`/api/programs/${id}`, data);
  },

  /**
   * Delete a program (soft delete)
   */
  delete: async (id: string): Promise<void> => {
    return apiClient.delete<void>(`/api/programs/${id}`);
  },
};

export default programsApi;
